var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C9.59647 0 10.08 0.483532 10.08 1.08V7.92H16.92C17.5165 7.92 18 8.40353 18 9C18 9.59647 17.5165 10.08 16.92 10.08H10.08V16.92C10.08 17.5165 9.59647 18 9 18C8.40353 18 7.92 17.5165 7.92 16.92V10.08H1.08C0.483532 10.08 0 9.59647 0 9C0 8.40353 0.483532 7.92 1.08 7.92H7.92V1.08C7.92 0.483532 8.40353 0 9 0Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGray);
export default __webpack_public_path__ + "static/media/plusGray.b184bceb147688d24579c417c2493f21.svg";
export { ForwardRef as ReactComponent };